// removed by extract-text-webpack-plugin
module.exports = {"activityInfo":"activityInfo__jmWDb","activityTitle":"activityTitle__1aTLR","activitySubtitle":"activitySubtitle__1RuhX","activityFollowButton":"activityFollowButton__331Jt"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/ActivityInfo/index.css
// module id = 1361
// module chunks = 0